<div class="container">
  <div class="legal-entity-name-container">
    <div>
      <dx-text-box
        id="newLegalEntity"
        [style]="{ width: '100%' }"
        placeholder="Legal entity name"
        [(value)]="newLegalEntity"
        >
      </dx-text-box>
    </div>
    <div class="decision-container">
      <p class="decision-text">Is this legal entity financially regulated (FSP)?</p>
      <dx-radio-group
        id="radio-group-with-selection"
        [items]="radioValues"
        valueExpr="id"
        layout="horizontal"
        displayExpr="valueText"
        [(value)]="selectionRadio"
        (onValueChanged)="onRadioValueChanged($event)"
      >
      </dx-radio-group>
    </div>
  </div>
  <div class="legal-entity-type-container">
    <div style="width: 100%; margin: 0px 20px 0px 0px">
      <dx-select-box
              [dataSource]="newCountryNameResults"
              [(value)]="selectedCountryId"
              displayExpr= "description"
              valueExpr="id"
              [searchEnabled]="true"
              [showClearButton]="false"
              placeholder="Legal entity type"
              (onValueChanged)="onLegalEntityTypeValueChanged($event)">
      </dx-select-box>
    </div>
    <div style="width: 100%" *ngIf="showFSPInput">
      <dx-text-box
        id="newLegalEntity"
        [style]="{ width: '100%' }"
        placeholder="FSP number"
        [(value)]="fspNumber"
        maxlength="6"
        >
      </dx-text-box>
    </div>
  </div>
  <hr class="hr-line" />
  <div class="buttons">
    <dx-button
                text="Cancel"
                  stylingMode="outlined"
                  type="default"
                  icon=""
                  (onClick)="cancel()">
    </dx-button>
    <dx-button
            text="Add legal entity"
              stylingMode="contained"
              type="default"
              icon=""
              class="business-approve-fica-button"
              (onClick)="submitNewLegalEntity()">
    </dx-button>
  </div>
</div>
